import gql from 'graphql-tag';

const royaltyQueries = {
  RoyaltySearch: (options) => {
    return gql`
      query {
        royaltySearch (
          input: {
            searchTerm: "${options.searchTerm}"
            limit: ${options.limit}
            offset: ${options.offset}
            orderBy: "${options.orderBy}"
            orderByDirection: "${options.orderByDirection}"
            dateFrom: "${options.dateFrom}"
            dateTo: "${options.dateTo}"
          },
          currency: ${options.currency}
         ) {
          count
          royalties {
            authorId
            authorFullName
            royaltyPercentage
            totalSales
            totalRoyalty
          }
        }
      }
    `;
  },
  RoyaltyDetails: (options) => {
    return gql`
      query {
        royaltyDetails (
          input: {
            searchTerm: "${options.searchTerm}"
            limit: ${options.limit}
            offset: ${options.offset}
            orderBy: "${options.orderBy}"
            orderByDirection: "${options.orderByDirection}"
            dateFrom: "${options.dateFrom}"
            dateTo: "${options.dateTo}"
          },
          authorId: ${options.authorId}
         ) {
          count
          authorSalesItems {
            id
            salesDate
            salesUSD
            salesGBP
            salesEUR
            salesCAD
            salesAUD
            salesNZD
            purchaseItem {
              id
              discount
              discountType
              product {
                id
                title
              }
            }
          }
        }
      }
    `;
  }
};

export default royaltyQueries;
